import { useQuery } from '@tanstack/react-query'
import userQueryKeys from './userQueryKeys'
import { fetchCompanyUsers } from '../service/userService'

export const useCompanyUsers = (companyId: string) => {
  return useQuery({
    queryKey: userQueryKeys.companyUsers(companyId),
    queryFn: fetchCompanyUsers,
    enabled: !!companyId,
    staleTime: 5 * 60 * 1000 // 5 minutes - users don't change often
  })
}
